'use client';

import Button, { ButtonVariants, type ButtonIconElement } from '@pixum/button';
import { redirectToWithPageReload } from 'utils';
import { trackBackButtonClick } from '../../analytics/overview';

interface BackButtonProps {
  label: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  leadingIcon?: ButtonIconElement;
  dataTestId?: string;
}

export function BackButton({
  label,
  href,
  onClick,
  className,
  leadingIcon,
  dataTestId = 'cart-back-button'
}: BackButtonProps) {
  const handleClick = () => {
    trackBackButtonClick();
    redirectToWithPageReload('/');
  };

  return (
    <Button
      variant={ButtonVariants.SECONDARY}
      href={href}
      onClick={href ? onClick : handleClick}
      data-testid={dataTestId}
      className={className}
      leadingIcon={leadingIcon}
    >
      {label}
    </Button>
  );
}
